export default "__VITE_ASSET__f91dea66__"